import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import useWindowSize from '../../../hooks/useWindowSize'
import {useRecipes} from '../../recipes/hooks'
import {createMeal,editMeal} from '../../../state/events'
import {update as updateResourceLibrary} from '../slice'
import MacroTotals from '../../recipes/MacroTotals'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import {slidingQueryComparision} from '../../../util/util'

const Recipe = ({recipe})=>{
	const dispatch = useDispatch()
	//get replace state. This holds the id and type of the item
	//getting replaced. The id will be falsey if not replacing
	const {replace,insertPosition} = useSelector(
		state => state.resourceLibrary
	)
	const replacing = Boolean(replace.id)

	const [status,setStatus] = useState('idle')
	const handleCreateMeal = ()=>{
		setStatus('pending')
		dispatch(
			createMeal({
				routine_order:Number(insertPosition),
				recipe_id:recipe.id,
				name:recipe.name
			})
		)
		.then(()=>{
			setStatus('idle')
		})
		dispatch(updateResourceLibrary({insertPosition:Number(insertPosition)+1}))
	}

	const handleReplaceMeal = ()=>{
		setStatus('pending')
		dispatch(editMeal({
			id:replace.id,
			recipe_source:'custom',
			update:{recipe_id:recipe.id,recipe_source:'custom'}
		})).then(()=>{
			setStatus('idle')
		})
	}
	
	const handleClick = ()=>{
		if(replacing){
			handleReplaceMeal()
		}else {
			handleCreateMeal()
		}
	}
	
	return (
		<div 
			className="d-flex align-items-center"
			style={{
				borderBottom:'1px solid #ccc',
				paddingBottom:'4px',
				marginBottom:'4px',
				paddingLeft:'4px'
			}}
		>
			<Button
				onClick={handleClick}
				variant="outline-success"
				className="mr-2"
				size="sm"
			>
				{status==='pending'&&
					<Spinner animation="border" size="sm"/>
				}
				{status==='idle'&&
					<i className={replacing?'fa fa-exchange-alt':"fa fa-plus"}/>
				}
			</Button>
			{Boolean(recipe.image)&&
				<img 
					style={{objectFit:'cover',width:'40px',height:'40px'}}
					className="rounded mr-2"
					src={recipe.image}
				/>
			}
			<div>
				<small><strong>{recipe.name}</strong></small>
				<MacroTotals foods={recipe.foods} align="left"/>
			</div>
		</div>
	)
}

const Recipes = ({typeSelector})=>{
	const {status,recipes} = useRecipes()
	const [windowWidth,windowHeight] = useWindowSize()
	const isLoading = status !== 'idle'
	const [query,setQuery] = useState('')
	const sortedRecipes = (
		Boolean(query)
		? [...recipes].sort( (a,b) => slidingQueryComparision(a.name,b.name,query) )
		: recipes.sort( (a,b) => a.name < b.name ? -1 : 1 )
	)
	return (
		<div 
			style={{
				width:'100%',
				height:'100%',
			}}
			className="d-flex align-items-stretch flex-column flex-md-row"
		>
			<div 
				className="p-2" 
				style={{
					background:'#e5e7f5',
					width:windowWidth>767?'180px':'100%',
					flex:'0 0 auto'
				}}
			>
				{typeSelector}
				<Form.Control 
					onChange={e=>{
						setQuery(e.target.value)
					}}
					value={query}
					placeholder="search"
					size="sm"
				/>
			</div>
			<div style={{flex:'1 1 auto',overflow:'scroll'}}>
				{isLoading&&<Spinner animation="border"/>}
				{recipes.length > 0 &&
					sortedRecipes.map(recipe=><Recipe key={recipe.id} recipe={recipe}/>)
				}
			</div>
		</div>
	)
}

export default Recipes